const mutations = {
  UPDATE_ID(state, id) {
    state.id = id
  },
  UPDATE_POSITION(state, position) {
    state.position = position
  },
  UPDATE_TYPE_OF_WORK(state, typeOfWork) {
    state.typeOfWork = typeOfWork
  },
  UPDATE_MONTHLY_INCOME(state, monthlyIncome) {
    state.monthlyIncome = monthlyIncome
  },
  UPDATE_EMPLOYMENT_SECTOR(state, employmentSectorId) {
    state.employmentSectorId = employmentSectorId
  },
  UPDATE_EMPLOYER_NAME(state, employerName) {
    state.employerName = employerName
  },
  UPDATE_EMPLOYER_ADDRESS(state, employerAddressId) {
    state.employerAddressId = employerAddressId
  },
  UPDATE_START_DT(state, startDt) {
    state.startDt = startDt
  },
  UPDATE_END_DT(state, endDt) {
    state.endDt = endDt
  },
}

const actions = {

  
  updateId({
    commit
  }, id) {
    commit('UPDATE_ID', id);
  },
  updatePosition({
    commit
  }, position) {
    commit('UPDATE_POSITION', position);
  },
  updateTypeOfWork({
    commit
  }, typeOfWork) {
    commit('UPDATE_TYPE_OF_WORK', typeOfWork);
  },
  updateMonthlyIncome({
    commit
  }, monthlyIncome) {
    commit('UPDATE_MONTHLY_INCOME', monthlyIncome);
  },
  updateEmploymentSector({
    commit
  }, employmentSectorId) {
    commit('UPDATE_EMPLOYMENT_SECTOR', employmentSectorId);
  },
  updateEmployerName({
    commit
  }, employerName) {
    commit('UPDATE_EMPLOYER_NAME', employerName);
  },
  updateEmployerAddress({
    commit
  }, employerAddressId) {
    commit('UPDATE_EMPLOYER_ADDRESS', employerAddressId);
  },
  updateStartDt({
    commit
  }, startDt) {
    commit('UPDATE_START_DT', startDt);
  },
  updateEndDt({
    commit
  }, endDt) {
    commit('UPDATE_END_DT', endDt);
  },
}

const getters = {
  Id: state => {
    return state.id
  },
  Position: state => {
    return state.position
  },
  TypeOfWork: state => {
    return state.typeOfWork
  },
  MonthlyIncome: state => {
    return state.monthlyIncome
  },
  EmploymentSector: state => {
    return state.employmentSectorId
  },
  EmployerName: state => {
    return state.employerName
  },
  EmployerAddress: state => {
    return state.employerAddressId
  },
  StartDt: state => {
    return state.startDt
  },
  EndDt: state => {
    return state.endDt
  },
}

const employmentHistory = {
  namespaced: true,
  state() {
    return {
      id: 0,
      position: "",
      typeOfWork: "",
      monthlyIncome: 0,
      employmentSectorId: 0,
      employerName: "",
      employerAddressId: 0,
      startDt: "",
      endDt: "",
    }
  },
  getters,
  actions,
  mutations
}

export default employmentHistory
